import { z } from "zod";

const boolEnvVar = z
  .string()
  .optional()
  .transform((s) => s == "true");

export const envVars = z
  .object({
    VITE_IS_REACTQUERYDEVTOOLS_ENABLED: boolEnvVar,
    VITE_SENTRY_DNS: z.string(),
    VITE_API_URL: z.string(),
    VITE_JSON_BASEPATH: z.string(),
    VITE_FF_INSTRUCTION_FOLDERS_BY_CATEGORY: boolEnvVar,
  })
  .parse(import.meta.env);
